<edit-component [rota]="'skins'" [resource]="skinResource" [service]="skinService"></edit-component>
